import { Table } from "antd";
import { Tooltip } from "antd";
import { useHistory } from "react-router-dom";

import { EyeOutlined } from "@ant-design/icons";
import { useMemo } from "react";

export function TableEstagio({ data, onChangePage, page, size, totalElements, module, loading }) {
  const history = useHistory();
  

  const dataSource = useMemo(() => data.map( value => ({ ...value, key: value.id , deferidoTeste: value.deferido})), [data]);
  const cpfMask = value => {
    return value
      .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
      .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
  }
  const columns = [
    {
      title: "NOME",
      dataIndex: "nome",
      key: "name",
      align: "center",
    },
    {
      title: "CPF",
      dataIndex: "cpf",
      key: "cpf",
      align: "center",
      render: (record) => (<>{cpfMask(record)} </>)
    },
    {
      title: "CURSO",
      dataIndex: "curso",
      key: "curso",
      align: "center",
    },
    {
      title: "SEMESTRE",
      dataIndex: "semestre",
      key: "semestre",
      align: "center",
    },
    {
      title: "INSTITUIÇÃO",
      dataIndex: "instituicao",
      key: "instituicao",
      align: "center",
    },
    // {
    //   title: "TURNO CURSO",
    //   dataIndex: "turnoCurso",
    //   key: "turnoCurso",
    //   align: "center",
    // },
    {
      title: "DISPONIBILIDADE",
      dataIndex: "turnoDisponibilidade",
      key: "turnoDisponibilidade",
      align: "center",
    },
    {
      title: "STATUS",
      dataIndex: "situacao",
      key: "situacao",
      align: "center",
      render: (record) => (<>{record? record : "INSCRITO"} </>)
      //  render: (record) => (<>{console.log(record)} </>)
    },
    {
      title: "VISUALIZAR",
      key: "action",
      align: "center",
      render: (record) => (
        <>
          <div onClick={() => history.push(`/detalhesEstagio/`+record.cpf)}>
            <Tooltip title="Visualizar Dados">
              <EyeOutlined style={{ fontSize: "18px", cursor: "pointer" }} />
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  return (
    <Table
      tableLayout="unset"
      loading={loading}
      dataSource={dataSource}
      columns={columns}
      mobileBreakPoint={768}
      size = "small"
      // bordered = "true"
      scroll={{ x: 500 }}
      pagination={{
        position: ['bottomCenter'],
      
        onChange: pageChange => {
          onChangePage(pageChange);
        },
        pageSize: size,
        current: page,
        defaultCurrent: page,
        total: totalElements,
        showSizeChanger: false
      }}
    />
  );
}
